import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import ContentCutOutlined from "@mui/icons-material/ContentCutOutlined";
import PageHeader from "../../common/PageHeader";
import CreateClipView from "./components/CreateClipView";
import ClipLibraryView from "./components/ClipLibraryView";

export default function AiClipping({ lang }) {
  const [tab, setTab] = React.useState(0);

  React.useEffect(() => {
    const onPrepare = (e) => {
      if (e.detail?.tourId === "ai-clipping") setTab(0);
    };
    window.addEventListener("beyundai:prepare-tour", onPrepare);
    return () => window.removeEventListener("beyundai:prepare-tour", onPrepare);
  }, []);

  return (
    <Box>
      <PageHeader
        title={lang?.aiClippingNav || "AI Clipping"}
        subtitle={
          lang?.aiClippingSubtitle ||
          "Turn long-form videos into viral short clips with AI captions — saved to your library and ready to share."
        }
        icon={ContentCutOutlined}
      />

      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        data-tour="ai-clipping-tabs"
        sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}
      >
        <Tab
          data-tour="ai-clipping-tab-create"
          label={lang?.aiClippingTabCreate || "Create clips"}
        />
        <Tab
          data-tour="ai-clipping-tab-library"
          label={lang?.aiClippingTabLibrary || "My clips"}
        />
      </Tabs>

      {tab === 0 && (
        <CreateClipView lang={lang} onViewLibrary={() => setTab(1)} />
      )}
      {tab === 1 && <ClipLibraryView lang={lang} />}
    </Box>
  );
}
